import { Files } from './files';
import { User } from './user';

export interface Discount {
   _id: string;
   status: boolean;
   usage_type: 'unique-code' | string;
   amount: number;
   amount_type: TAmountType;
   code: string;
   isMultiple: boolean;
   expiry_date: string;
   deletedAt: string | null;
   createdAt: string;
   updatedAt: string;
   meta?: {
      title: string;
      description: string;
      termsAndConditions: string;
      discount_id: string;
      userType: string;
      image: Files;
   };
   owner?: User;
}

export const AmountType = {
   PERCENTAGE: 'percentage',
   FIXED: 'fixed',
} as const;

export type TAmountType = (typeof AmountType)[keyof typeof AmountType];
